import {
	type InfiniteData,
	infiniteQueryOptions,
	type QueryKey,
	type UseInfiniteQueryOptions,
} from "@tanstack/react-query";

type PaginatedQueryResult<T> = {
	data: T[];
	totalCount: number;
	currentPage: number;
	totalPages: number;
};

export function createInfiniteQueryOptions<T>({
	queryKey,
	queryFn,
	initialPageParam = 1,
	...options
}: {
	initialPageParam?: number;
} & Omit<
	UseInfiniteQueryOptions<
		PaginatedQueryResult<T>,
		Error,
		InfiniteData<PaginatedQueryResult<T>>,
		QueryKey,
		number | null | undefined
	>,
	"getPreviousPageParam" | "getNextPageParam" | "initialPageParam"
>) {
	return infiniteQueryOptions({
		...options,
		queryKey,
		queryFn,
		initialPageParam,
		getNextPageParam: (lastPage) =>
			lastPage?.currentPage && lastPage.currentPage < lastPage.totalPages
				? lastPage.currentPage + 1
				: undefined,
		getPreviousPageParam: (firstPage) =>
			firstPage?.currentPage && firstPage.currentPage > 1
				? firstPage.currentPage - 1
				: undefined,
	});
}
